/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react'
import { useSelector } from 'react-redux'
import { useOutletContext } from 'react-router-dom'
import TabWithSubNav from '../../../../TabWithSubNav'
import OccupationsSection from './OccupationsSection'
import TemplateSection from './TemplateSection'
import MessagingSection from './MessagingSection'
import DataSharingSection from './DataSharingSection'
import EmailSection from './EmailSection'
import LoginsSection from './LoginsSection'
import DefaultRedirectSection from './DefaultRedirectSection'
import { hasPolicy } from '../../../../../redux/selectors'
import {
  ACCESS_LISTING_SETTINGS_DATA_SHARING_TAB,
  ACCESS_LISTING_SETTINGS_VERIFICATION_TYPES_TAB,
} from '../../../../../auth/policies'

export function SettingsTab() {
  const { verificationListing: listing } = useOutletContext()
  const canAccessListingSettingsDataSharingTab = useSelector(hasPolicy(ACCESS_LISTING_SETTINGS_DATA_SHARING_TAB))
  const canAccessListingSettingsVerificationTypesTab = useSelector(hasPolicy(ACCESS_LISTING_SETTINGS_VERIFICATION_TYPES_TAB))

  if (!listing) {
    return null
  }

  return (
    <TabWithSubNav
      items={[
        { primaryText: 'Affiliations', component: <OccupationsSection listing={listing} /> },
        { primaryText: 'Customize Display', component: <TemplateSection listing={listing} /> },
        { primaryText: 'Customize Messaging', component: <MessagingSection listing={listing} /> },
        ...(canAccessListingSettingsDataSharingTab ? [{ primaryText: 'Data Sharing', component: <DataSharingSection listing={listing} /> }] : []),
        { primaryText: 'Email Settings', component: <EmailSection listing={listing} /> },
        { primaryText: 'Logins', component: <LoginsSection listing={listing} /> },
        { primaryText: 'Default Redirect', component: <DefaultRedirectSection listing={listing} /> },
      ]}
    />
  )
}

export default SettingsTab
